import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

export default {

  namespaced: true,

  actions: {

    async getCouriers({commit}) {
      try {
        let res = await axios.get('/courier');
        commit("SET_COURIERS", res.data.data);
      } catch(e) {
        throw(e);
      }
    },

    async getOrganizationProvider({commit}, org_id) {
      try {
        let res = await axios.get(`/organization/${org_id}/fulfillment-provider`);
        commit("SET_ORGANIZATION_PROVIDERS", res.data.data);
      } catch(e) {
        console.log(e);
      }
    },

    async getProviders({commit}) {
      try {
        let res = await axios.get(`/fulfillment`);
        commit("SET_PROVIDERS", res.data.data);
      } catch(e) {
        throw(e);
      }
    },

    async bulkUpdate({commit, state}) {
      let data = JSON.parse(JSON.stringify(state.organization_providers));
      try {
        let res = await axios.put('/organization/:id/fulfillment-provider', data);
        commit('SET_ORGANIZATION_PROVIDERS', res.data.data);
      } catch(e) {
        console.dir(e);
      }
    },
  },

  getters: {
  },

  mutations: {

    SET_PROVIDERS(state, payload) {
      state.providers = payload;
    },

    SET_ORGANIZATION_PROVIDERS(state, payload) {
      for (let row of payload) {
        row.apikey_display = ''; // default to blank
        for (let field of row.api_key_values) {
          if (field.name === 'apikey' || field.name === 'api_key') {
            row.apikey_display = field.value;
            break;
          }
        }
      }

      state.organization_providers = payload;
    },

    SET_COURIERS(state, payload) {
      state.couriers = payload;
    },

    ADD_FULFILLIMENT(state, payload) {
      let idx = state.organization_providers.findIndex(
        (x) => x.fullfillment_provider_id == payload.fullfillment_provider_id
      );

      for (let field of payload.api_key_values) {
        if (field.name === 'apikey' || field.name === 'api_key') {
          payload.apikey_display = field.value;
        }
      }

      if (idx < 0) {
        state.organization_providers.push(payload);
      } else {
        state.organization_providers[idx] = payload;
      }
    },

    REMOVE_FULFILLMENT(state, payload) {
      state.organization_providers = state.organization_providers.filter(
        (x) => {
          return x.fullfillment_provider_id !== payload.fullfillment_provider_id;
        }
      );
    }
  },

  state: {
    providers: [],
    organization_providers: [],
    couriers: [],
  },
}
